import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import routes from '../../../shared/routes';
import { showAccountNumber, showCode } from '../../../shared/helper/commonBankDetails';
import httpClient from '../../../shared/libraries/httpClient';

const ShowBankDetails = ({ currency }) => {
  const [bankDetails, setBankDetails] = useState({});

  const fetchBankDetails = async () => {
    const { data } = await httpClient.get(routes.bankDetails.fetch({ currency_code: currency }));
    setBankDetails(data.bankDetails);
  };

  useEffect(() => {
    if (currency) {
      fetchBankDetails();
    }
  }, [currency]);

  return (
    <div className="billing-invoice__details-bank-info-details-wrapper">
      <div className="billing-invoice__details-bank-info-details-currency">
        {bankDetails.currencyCode}
      </div>
      <div className="billing-invoice__details-bank-info-details-currency--name">
        {bankDetails.currencyName}
      </div>
      <div className="billing-invoice__details-bank-info-details-account-number">
        {showAccountNumber(bankDetails)}
      </div>
      <div className="billing-invoice__details-bank-info-details-bank-name">
        {I18n.t('components.billing.invoices.bank_account_details.bank', {
          name: bankDetails.bankName,
        })}
      </div>
      <div className="billing-invoice__details-bank-info-details-bank-code">
        {showCode(bankDetails)}
      </div>
      <div className="billing-invoice__details-bank-info-details-bank-beneficiary">
        {I18n.t('components.billing.invoices.bank_account_details.beneficiary', {
          beneficiary: bankDetails.beneficiary,
        })}
      </div>
      <div className="billing-invoice__details-bank-info-details-bank-beneficiary-address">
        {I18n.t('components.billing.invoices.bank_account_details.beneficiary_address', {
          beneficiary_address: bankDetails.beneficiaryAddress,
        })}
      </div>
    </div>
  );
};

ShowBankDetails.defaultProps = {
  currency: 'usd',
};

ShowBankDetails.propTypes = {
  currency: PropTypes.string,
};

export default ShowBankDetails;
